(ns hypnos.logging
  "Wrapper for logging."
  (:require ["aws-amplify" :as amp :refer (Logger)]
            [hypnos.config :as config]))


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Identities

(def logger (Logger. "hypnos" (if config/debug? "DEBUG" "INFO")))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; API

(defn debug
  "Log a debug statement."
  ([message]
   (.debug logger message))
  ([message data]
   (.debug logger message data)))

(defn info
  "Log an informational statement."
  ([message]
   (.info logger message))
  ([message data]
   (.info logger message data)))

(defn warn
  "Log a warning."
  ([message]
   (.warn logger message))
  ([message data]
   (.warn logger message data)))

(defn error
  "Log an error."
  ([message]
   (.error logger message))
  ([message data]
   (.error logger message data)))
